function toggleFilters() {
    const sidebar = document.querySelector('.VarCol-custom-sidebar-filters');
    sidebar.classList.toggle('active');
    document.body.classList.toggle('VarCol-no-scroll');
}

document.addEventListener('click', function(event) {
    const sidebar = document.querySelector('.VarCol-custom-sidebar-filters');
    if (sidebar && sidebar.classList.contains('active')) {
        document.body.style.overflow = 'hidden';
    } else {
        document.body.style.overflow = 'auto';
    }
});

document.querySelectorAll('.VarCol-accordion-button').forEach(button => {
    button.addEventListener('click', () => {
        button.classList.toggle('open');
        const content = button.nextElementSibling;
        content.style.display = content.style.display === 'block' ? 'none' : 'block';
    });
});

function VarColApplySort() {
    const sortBy = document.getElementById('VarCol-sort-by').value;
    const grid = document.getElementById('VarCol-variant-collection-product-grid');
    const items = Array.from(grid.getElementsByClassName('VarCol-variant-collection-item'));

    items.sort((a, b) => {
        const priceA = parseFloat(a.dataset.price);
        const priceB = parseFloat(b.dataset.price);
        return sortBy === 'price-low-to-high' ? priceA - priceB : priceB - priceA;
    });

    grid.innerHTML = '';
    items.forEach(item => grid.appendChild(item));
}